import { displayMessage } from '../../../services/helper';

export default (mobile_mode) => {

    return (
        [
            {
                field: 'Patient',
                headerName: displayMessage('PATIENT_NAME'),
                width: 200,
                headerAlign: "center",
                sortable: false,
                align: 'center',
                renderCell: (params) => {
                    let patient = params.formattedValue
                    return patient.full_name
                }
            },
            {
                field: 'User',
                headerName: displayMessage('RESPONSIBLE_USER'),
                width: 200,
                headerAlign: "center",
                sortable: false,
                align: 'center',
                renderCell: (params) => {
                    let user = params.formattedValue
                    return user.full_name
                }
            },
            {
                field: 'action_name',
                headerName: displayMessage('ACTION'),
                width: 160,
                headerAlign: 'center',
                sortable: false,
                align: 'center',
            },
            {
                field: 'created_date',
                headerName: displayMessage('ACTION_DATE'),
                flex: 1,
                minWidth: mobile_mode ? 300 : 120,
                type: 'string',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
            }
        ]
    )
}